import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="min-h-screen bg-gradient-to-b from-beauty-pink/30 to-white flex items-center">
      <div className="container-custom py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="text-center md:text-left reveal">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-beauty-rose mb-4">
              Beauty & Grace
            </h1>
            <h2 className="text-2xl md:text-3xl font-playfair mb-6 text-gray-700">
              Discover Your Radiance at Anjana Beauty Care
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-lg mx-auto md:mx-0">
              Premium salon services for women who appreciate elegance, quality, and personal care.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <a href="#contact" className="btn-primary flex items-center justify-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                Call Now
              </a>
              <a href="#contact" className="btn-secondary flex items-center justify-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                </svg>
                WhatsApp Us
              </a>
            </div>
          </div>
          <div className="hidden md:block reveal-right">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-64 h-64 bg-beauty-rose/20 rounded-full"></div>
              <img 
                src="/images/hero/hero-image.jpg" 
                alt="Elegant Woman" 
                className="w-full h-auto rounded-lg shadow-lg relative z-10"
              />
              <div className="absolute -bottom-4 -right-4 w-48 h-48 bg-beauty-pink/30 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
